"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YanziModel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_maps_1 = require("@yanzi/react-maps");
const react_models_1 = require("@yanzi/react-models");
const react_ui_1 = require("@yanzi/react-ui");
const react_error_boundary_1 = require("react-error-boundary");
const hooks_1 = require("../../../../hooks");
function YanziModel(_a) {
    var { layer, opacity } = _a, props = __rest(_a, ["layer", "opacity"]);
    const { accountNumber } = hooks_1.useSiteAccountNumber();
    if (!layer.yanziModelId) {
        throw new Error('No Yanzi model ID');
    }
    const { data, isLoading } = react_models_1.useModelsFeatureCollection(accountNumber, layer.yanziModelId);
    if (!data) {
        return isLoading ? jsx_runtime_1.jsx(react_ui_1.BarLoader, {}, void 0) : null;
    }
    if (!data.features) {
        return jsx_runtime_1.jsx("div", { children: "Missing features" }, void 0);
    }
    return (jsx_runtime_1.jsx(react_error_boundary_1.ErrorBoundary, Object.assign({ fallback: null }, { children: data.features.map(feature => (jsx_runtime_1.jsx(react_maps_1.GeoJSONFeature, Object.assign({}, props, { feature: feature }), feature.id))) }), void 0));
}
exports.YanziModel = YanziModel;
//# sourceMappingURL=YanziModel.js.map